module.exports = __webpack_public_path__ + "img/gr.cd20810a.svg";